import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const updateUrlVideo = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.SETTINGS.UPDATE_VIDEO_YOUTUBE}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default updateUrlVideo;